export default "__VITE_ASSET__aeb10458__"